module.exports = __webpack_public_path__ + "img/azure-file.d5be91be.svg";